export const defaultImageCategories = ['identicon', 'mp', 'monsterid', '404', 'wavatar', 'retro', 'robohash', 'blank']
